<template>
    <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <a-row :gutter="24">
                <div class="hidden">
                    <a-form-item label="id" name="id">
                        <a-input v-model:value="form.id"/>
                    </a-form-item>
                </div>
                <a-col :span="12">
                    <a-form-item label="企业名称" name="companyName">
                        <a-input v-model:value="form.companyName" :disabled="form.companyName" placeholder="请输入企业名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="地区" name="prov">
                        <city-select v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
                                     placeholder="请选择省/市/区"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="详细地址" name="detailedAddress">
                        <a-input v-model:value="form.detailedAddress" placeholder="请输入详细地址"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="邮政编码" name="postalCode">
                        <a-input v-model:value="form.postalCode" placeholder="请输入邮政编码"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="注册时间（企业成立时间）" name="registerTime">
                        <date-picker v-model:value="form.registerTime" style="width: 100%" placeholder="请选择注册时间"/>
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="12">
                  <a-form-item label="入驻时间" name="checkinTime">
                    <date-picker v-model:value="form.checkinTime" style="width: 100%" placeholder="请选择入驻时间" />
                  </a-form-item>
                </a-col> -->
                <a-col :span="12">
                    <a-form-item label="注册资本(万元)" name="registerMoney">
                        <a-inputNumber v-model:value="form.registerMoney" style="width: 100%" placeholder="请输入注册资本"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="企业性质" name="businessScope">
                        <DictSelect v-model:value="form.businessScope" :dict-name="'businessScope'" placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="12">
                  <a-form-item label="行业类型" name="companyProperty">
                    <DictSelect v-model:value="form.companyProperty" :dict-name="'projecttype'" placeholder="请选择" />
                  </a-form-item>
                </a-col> -->
                <a-col :span="12">
                    <a-form-item label="所属领域" name="companyDomain">
                        <DictSelect v-model:value="form.companyDomain" :dict-name="'corpbelong_type'" placeholder="请选择"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="所属园区" name="baseNId">
                        <single-select placeholder="请选择所属园区" v-model:value="form.baseNId" :options="baseNameoptions" @change="form.baseCId = null" titleName="baseName" valueName="id"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="所属载体" name="baseCId">
                        <single-select placeholder="请选择所属载体" v-model:value="form.baseCId" :options="childrenBaseNameoptions" titleName="baseName" valueName="id"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="统一社会信用代码" name="oraganizationCode">
                        <a-input v-model:value="form.oraganizationCode" disabled placeholder="请输入统一社会信用代码"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="企业邮箱" name="comEmail">
                        <a-input v-model:value="form.comEmail" placeholder="请输入企业邮箱"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="企业法人" name="corporation">
                        <a-input v-model:value="form.corporation" placeholder="请输入企业法人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12" style="position: relative;">
                    <a-form-item label="法人电话" name="contactsMobile">
                        <div style="width:80%;position:absolute;top:-30px;left:66px;color:#ff5658;">
                            （必须为法人真实手机号，用于后续接收重要通知）
                        </div>
                        <a-input v-model:value="form.contactsMobile" disabled placeholder="请输入法人电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人" name="linkman">
                        <a-input v-model:value="form.linkman" placeholder="请输入联系人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="phone">
                        <a-input v-model:value="form.phone" placeholder="请输入联系电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="企业logo" name="companyLogo">
                        <img-upload v-model:value="form.companyLogo"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="营业执照(PDF格式)" name="licenceFile">
                        <file-upload v-model:value="form.licenceFile" :size="50" :isPdf="true"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="企业法人身份证" name="legalPersonCard">
                        <file-upload v-model:value="form.legalPersonCard" :size="500" :isPdf="true"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="企业简介" name="description">
                        <a-textarea v-model:value="form.description" placeholder="请输入企业简介" :auto-size="{ minRows: 4, maxRows: 6 }"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import {formMixin} from "@/mixins";
import {companyInfo} from "@/api/companyService";
import DictSelect from "@/components/other/DictSelect";
import dataCheck from "@/utils/dataCheck";
import {innovationBaseInfo} from "@/api/finance";

export default {
    name: "UserModal",
    components: {DictSelect,},
    mixins: [formMixin],
    data() {
        return {
            baseNameoptions: null,
            childrenBaseNameoptions:[],
            form: {
                id: null,
                companyCode:null
            },
            rules: {
                id: [],
                companyName: [dataCheck.required({})],
                prov: [],
                city: [],
                dist: [],
                companyCode:[],
                baseNId: [dataCheck.required({})],
                baseCId:[],
                detailedAddress: [dataCheck.required({})],
                postalCode: [],
                registerTime: [],
                checkinTime: [],
                registerMoney: [dataCheck.required({type: "number"})],
                businessScope: [],
                oraganizationCode: [dataCheck.required({})],
                comEmail: [dataCheck.required({}), dataCheck.email],
                companyProperty: [dataCheck.required({})],
                companyDomain: [dataCheck.required({})],
                baseName: [dataCheck.required({})],
                corporation: [dataCheck.required({}), dataCheck.chineseString],
                contactsMobile: [dataCheck.required({}), dataCheck.mobile_phone],
                linkman: [dataCheck.required({}), dataCheck.chineseString],
                phone: [dataCheck.required({}), dataCheck.phone],
                companyLogo: [],
                licenceFile: [dataCheck.required({})],
                legalPersonCard: [dataCheck.required({})],
                description: [dataCheck.required({}), dataCheck.allSpace]
            },
            submitUrl: companyInfo.saveorupdate
        }
    },
    mounted() {
        this.getinnovationBaseInfo();
        console.log("this.form", this.form)
    },
    watch: {
        'form.baseNId': {
            handler(newVal) {
                if (newVal && this.baseNameoptions) {
                    const selectedItem = this.baseNameoptions.find(item => item.id === newVal);
                    if (selectedItem) {
                        this.form.baseName = selectedItem.baseName;
                    }
                    this.getInnovationChildrenBaseInfo(newVal)
                } else if (!newVal) {
                    this.form.baseName = '';
                }
            },
            immediate: true
        }
    },
    methods: {
        /**
         * 获取园区信息
         */
        getinnovationBaseInfo() {
            this.getAction({
                    url: innovationBaseInfo.list,
                }
            ).then((res) => {
                this.baseNameoptions = res
            })
        },
        getInnovationChildrenBaseInfo(baseId){
            this.getAction(
                {
                    url: innovationBaseInfo.childrenList,
                    params: {
                        id: baseId
                    }
                }
            ).then((res) => {
                this.childrenBaseNameoptions = res
            })
        },
    },
}
</script>
<style scoped lang="less"></style>
